import React, { useEffect, useState, useRef } from "react";
import classes from "./CashManagement.module.css";
import HeaderNav from '../../Accoungting/HeaderNav/HeaderNav';
import Footer from "../../Accoungting/Footer/Footer";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../../Assets/searchicon.png";
import filter from "../../../Assets/filter.png";
import { Pen, Trash2, Printer } from "lucide-react";
import axios from "axios";
import { BASE_URL } from '../../../Components/Styles/API/API';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Button, Modal, Form, Spinner, Tab, Tabs, Row, Col, Popover } from 'react-bootstrap';
import Select from "react-select";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";
import Swal from "sweetalert2";
import CurrencyInput from "react-currency-input-field";
import CashReciept from "./CashReciept/CashReciept";





const CashReceiptss = () => {
  const location = useLocation();
  const navigate = useNavigate();
   const [openCashReciept, setOpenCashReciept] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const handleShow1 = () => setShow1(true);
  const handleShow2 = () => setShow2(true);
  const handleClose1 = () => setShow1(false);
  const handleClose2 = () => setShow2(false);
  const [selectedRadio, setSelectedRadio] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [bankOptions2, setBankOptions2] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedBank2, setSelectedBank2] = useState(null);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [addpaymenntLoad, setAddPaymenntLoad] = useState(false);
  const [addpaymenntLoad2, setAddPaymenntLoad2] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [totalEntries, setTotalEntries] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [bearer, setBearer] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [currLoading, setCurrLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [user, setUser] = useState('');
  const [currency, setCurrency] = useState([]);




  
    const readData = async () => {
      try {
        const value = await localStorage.getItem('userToken');
        const value1 = await localStorage.getItem('tobi');
  
  
        if (value !== null && value.trim() !== '') {
          setBearer(value);
        } else {
          navigate('/login');
          return;
        }
  
        if (value1 !== null) {
          setUser(value1);
        }
  
      } catch (e) {
        alert('Failed to fetch the input from storage');
      }
    };
  
    useEffect(() => {
      readData();
    }, []);


      const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  


  const printRef = useRef();
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };


    const handleRadioChange = (e) => {
    const value = e.target.value;
    setSelectedRadio(value);

    if (value === "general") {
      setSelectedCustomer(null);
    }
  };


  // useEffect(() => {
  //   const fetchInvoices = async () => {
  //     try {
  //       const token = localStorage.getItem("authToken");
  //       const res = await axios.get(`${BASE_URL}/v1/payments-made`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             Accept: "application/json",
  //           },
  //         }
  //       );
  //       if (res.data && res.data.status && Array.isArray(res.data.data)) {
  //         setInvoices(res.data.data);
  //       }
  //     } catch (err) {
  //       // Optionally handle error
  //       setInvoices([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchInvoices();
  // }, []);

    const handlePrevPage = () => {
    setCurrentPage(Math.max(currentPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(Math.min(currentPage + 1, totalPages));
  };

  // const totalEntries = filteredData.length;
  const startIndexx = (currentPage - 1) * entriesPerPage + 1;
  const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);


    const fetchInvoices = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/payments-made`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          setInvoices(res.data.data);
        }
      } catch (err) {
        setInvoices([]);
      } finally {
        setLoading(false);
      }
    };

    // load invoices on mount
    useEffect(() => {
      fetchInvoices();
    }, []);

    const fetchExpenses = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-all-payments?page=${currentPage}`, { headers });

      const results = response.data?.data?.data;
      const resultx = response.data?.data?.total;
      setTotalEntries(resultx);
      setTableData(results);
      // console.log(results, "accounts");
      const total = response.data?.data?.last_page || 1;
      setTotalPages(total);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData([]);
    } finally {
      setIsLoading(false);
    }
  };

    const fetchCurrency = async () => {
        setCurrLoading(true);
        try {
            const response = await axios.get(`${BASE_URL}/fetch-all-currencies`, { headers });
            const results = response.data?.data;
            // console.log(results, "currencis")
            const options = results.map((item) => ({
                label: item.name || item.code,
                value: item.id,
                symbol: item.symbol
            }));
            setCurrency(results);
            setCurrencyOptions(options);
        } catch (error) {
            const errorStatus = error.response?.data?.message;
            console.log(errorStatus);
            setCurrency([]);
        } finally {
            setCurrLoading(false);
        }
    };

  useEffect(() => {
    if (bearer) {
      fetchExpenses();
      fetchCurrency();
      //   fetchTotalExpenses();
    }
  }, [bearer, currentPage]);


    useEffect(() => {
      const fetchCurrencies = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/fetch-all-currencies`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.name || item.code,
            }))
            : [];
          setCurrencyOptions(options);
        } catch (err) {
          setCurrencyOptions([]);
        }
      };
      fetchCurrencies();
    }, []);

    useEffect(() => {
      const fetchBank = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/v1/get-cash-and-bank`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.gl_name,
            }))
            : [];
          setBankOptions(options);
        } catch (err) {
          setBankOptions([]);
        }
      };
      fetchBank();
    }, []);

    useEffect(() => {
      const fetchBank2 = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/v1/get-cash-and-bank`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.gl_name,
            }))
            : [];
          setBankOptions2(options);
        } catch (err) {
          setBankOptions2([]);
        }
      };
      fetchBank2();
    }, []);

    useEffect(() => {
      const fetchPaymentMode = async () => {
        try {
          const token = localStorage.getItem("userToken");
          const res = await axios.get(`${BASE_URL}/income/get-payment-method`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.name,
            }))
            : [];
          setPaymentMode(options);
        } catch (err) {
          setPaymentMode([]);
        }
      };
      fetchPaymentMode();
    }, []);


      useEffect(() => {
        const fetchCustomers = async () => {
          try {
            const token = localStorage.getItem("authToken");
            const res = await axios.get(`${BASE_URL}/v1/beneficiary`, {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });
            // Assuming response data is an array of currencies or customers
            const options = Array.isArray(res.data.data)
              ? res.data.data.map((item) => ({
                value: item.id,
                label: item.name,
              }))
              : [];
            setCustomerOptions(options);
          } catch (err) {
            setCustomerOptions([]);
          }
        };
        fetchCustomers();
      }, []);

      useEffect(() => {
        const fetchInvoiceOptions = async () => {
          try {
            const token = localStorage.getItem("authToken");
            const res = await axios.get(`${BASE_URL}/v1/fetch-pending-purchases-invoice`, {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });
            console.log(res);
            // Assuming response data is an array of currencies or customers
            const options = Array.isArray(res.data.data)
              ? res.data.data.map((item) => ({
                value: item.id,
                label: `${item.invoice_number} - ${item.supplier?.name}`,
                balance: item.balance,
              }))
              : [];
            setInvoiceOptions(options);
          } catch (err) {
            setInvoiceOptions([]);
          }
        };
        fetchInvoiceOptions();
      }, []);
  

  // Skeleton loader rows
  // const SkeletonRows = () => (
  //   <>
  //     {[...Array(5)].map((_, idx) => (
  //       <tr key={idx}>
  //         {Array(10).fill().map((_, i) => (
  //           <td key={i}>
  //             <div className={classes.skeletonLoader}></div>
  //           </td>
  //         ))}
  //       </tr>
  //     ))}
  //   </>
  // );

  // Helper for status
  const statusClass = (status) => {
    if (status === "Success") return classes.greenStatus;
    if (status === "Pending") return classes.yellowStatus;
    return classes.redStatus;
  };

    // useEffect(() => {
    //   const link = document.createElement("link");
    //   link.rel = "stylesheet";
    //   link.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css";
    //   document.head.appendChild(link);
    //   return () => {
    //     document.head.removeChild(link);
    //   };
    // }, []);

  const addPayment = async () => {
    setAddPaymenntLoad(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${BASE_URL}/v1/pay-purchase-invoice`, 

        {
          payment_type: selectedRadio,
          transaction_date: paymentDate,
          supplier_id: selectedCustomer?.value,
          supplier: customerName,
          description: description,
          payment_mode: selectedPaymentMode?.value,
          currency: selectedCurrency?.value,
          amount: amount,
          credit: selectedBank?.value,
          debit: selectedBank2?.value,
        },
        { headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });

          Swal.fire({
            imageUrl: verified,
            title: 'Success!',
            text: response.data.message,
            confirmButtonText: "Okay",
            imageWidth: 48, 
            imageHeight: 48, 
            customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
            },
            allowOutsideClick: false,
            preConfirm: () => {
              Swal.close();
            }
          });

          fetchInvoices();
          handleClose1();
          setDescription("");
          setAmount("");
          setCustomerName("");
          setPaymentDate("");
          setSelectedRadio("");
          setSelectedBank(null);
          setSelectedBank2(null);
          setSelectedCurrency(null);
          setSelectedCustomer(null);
          setSelectedPaymentMode(null);
      
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          imageUrl: crop,
          imageWidth: 48,
          imageHeight: 48,
          title: "Failed!",
          confirmButtonText: "Okay",
          text: JSON.stringify(error.response.data.message),
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myDeclineButton,
          },
          allowOutsideClick: false, // Prevent closing by clicking outside
          preConfirm: () => {
            Swal.close(); // Explicitly close the modal
          },
        });
      }
    } finally {
      setAddPaymenntLoad(false);
    }
  };

  const addPayment2 = async () => {
    setAddPaymenntLoad2(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${BASE_URL}/v1/pay-supplier-purchase-invoice`, 

        {
          // payment_type: selectedRadio,
          transaction_date: paymentDate,
          id: selectedInvoice?.value,
          description: description,
          payment_mode: selectedPaymentMode?.value,
          currency: selectedCurrency?.value,
          amount: amount,
          credit: selectedBank?.value,
          debit: selectedBank2?.value,
        },
        { headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });

          Swal.fire({
            imageUrl: verified,
            title: 'Success!',
            text: response.data.message,
            confirmButtonText: "Okay",
            imageWidth: 48, 
            imageHeight: 48, 
            customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
            },
            allowOutsideClick: false,
            preConfirm: () => {
              Swal.close();
            }
          });

          fetchInvoices();
          handleClose2();
          setDescription("");
          setAmount("");
          setCustomerName("");
          setPaymentDate("");
          setSelectedRadio("");
          setSelectedBank(null);
          setSelectedBank2(null);
          setSelectedCurrency(null);
          setSelectedCustomer(null);
          setSelectedPaymentMode(null);
      
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          imageUrl: crop,
          imageWidth: 48,
          imageHeight: 48,
          title: "Failed!",
          confirmButtonText: "Okay",
          text: JSON.stringify(error.response.data.message),
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myDeclineButton,
          },
          allowOutsideClick: false, // Prevent closing by clicking outside
          preConfirm: () => {
            Swal.close(); // Explicitly close the modal
          },
        });
      }
    } finally {
      setAddPaymenntLoad2(false);
    }
  };



//  const handlePrint = (rowData) => {
//   navigate("/invoice-previeww", {
//     state: {
//       invoiceNumber: rowData.invoice_number,
//       invoiceDate: rowData.invoice_date,
//       dueDate: rowData.due_date,
//       customer: {
//         name: rowData.customer_name,
//         phone_number: rowData.customer_phone,
//         email: rowData.customer_email,
//       },
//       items: rowData.items,
//       total: rowData.total,
//     },
//   });
// };

const handlePrint = (rowData) => {
  navigate("/invoice-previeww", {
    state: { invoice: rowData },
  });
};




  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />

      <div className={classes.Container}>
        {/* <div className={classes.actions}>

                    <button className={`${classes.btnss} ${classes.greens}`}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={classes.btns}>Product & Services </button>

                </div> */}
        <div className={classes.actionsbtn}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div>

        <header className={classes.Header}>
          <h2 className={classes.Title}>Cash Receipt</h2>
          <h1 className={classes.Titles}>
            Manage your receipt transactions, supplier invoices, and payments.
          </h1>
        </header>

          <Row>
            <Col md={3}>
              <div className={classes.thrdkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Total Debits</p>
                  <p className={classes.kdptg1}>₦0.00</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>This Period</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className={classes.frtkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Total Credits</p>
                  <p className={classes.kdptg2}>₦0.00</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>This Period</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className={classes.fiftkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Trial Balance</p>
                  <p className={classes.kdptg3}>₦0.00</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>This Period</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className={classes.frstkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Entries</p>
                  <p className={classes.kdptg4}>₦0.00</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>This Period</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search sales" />
            </div>
            <div className={classes.selectWrapper}>
              <select className={classes.dropdown}>
                <option value="">All Status</option>
                <option value="Paid">Paid</option>
                <option value="Pending">Pending</option>
                <option value="Overdue">Overdue</option>
                <option value="Draft">Draft</option>
              </select>
              <span className={classes.dropdownArrow}>▼</span>
            </div>

            <div className={classes.inputWrapper}>
              <input type="text" className={classes.searchBars} placeholder="Filter..." />
              <img src={filter} alt="Filter" className={classes.inputIcon} />
            </div>
          </div>
          <div className={classes.actionsLeft}>
            <button className={classes.btnss} onClick={() => setOpenCashReciept(true)} > + Cash Receipt</button>
          </div>
        </div>

        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <table className={classes.invoiceTable}>
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr>
                  <th>S/N</th>
                  <th>Date</th>
                  <th>Reference</th>
                  <th>Description</th>
                  <th>Account</th>
                  <th>Debit</th>
                  <th>Credit</th>
                  <th>Balance</th>
                  {/* <th>Action</th> */}
                </tr>
              </thead>
              <tbody>

                {isLoading
                  ? Array(5)
                    .fill()
                    .map((_, idx) => (
                      <tr key={idx}>
                        {Array(8)
                          .fill()
                          .map((_, i) => (
                            <td key={i}>
                              <Skeleton height={20} style={{ marginBottom: 10 }} />
                            </td>
                          ))}
                      </tr>
                    ))
                  : tableData.length === 0 ? (
                    <tr>
                      <td colSpan={10} style={{ textAlign: "center" }}>
                        No payment found.
                      </td>
                    </tr>
                  ) : (
                    tableData.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.transaction_date}</td>
                        <td>{item.invoice_number}</td>
                        <td>{item.description}</td>
                        <td>{item.supplier?.name || ""}</td>
                        {/* <td className={statusClass(item.status || "Pending")}>{item.status || "Pending"}</td> */}
                        <td style={{ textAlign: "right" }}>₦{Number(item.amount).toLocaleString()}</td>
                        <td style={{ textAlign: "right" }}>₦{Number(item.amount).toLocaleString()}</td>
                       <td style={{ textAlign: "right" }}>₦{Number(item.amount).toLocaleString()}</td>
                        {/* <td className={classes.actions}>
                          <Pen size={16} className={classes.editIcon} />
                          <Trash2 size={16} className={classes.deleteIcon} />
                          <Printer size={16} className={classes.printIcon} onClick={() => handlePrint(item)}
                            style={{ cursor: "pointer" }} />
                        </td> */}
                      </tr>
                    ))
                  )}
              </tbody>
            </table>


          </table>

          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button                   
                onClick={handlePrevPage}
                disabled={currentPage === 1}
              >Previous</button>
              {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return(
                <button className={classes.active}  key={page + 1}
                style={{
                  color: page + 1 === currentPage ? '#ffffff' : '#000',
                  backgroundColor: page + 1 === currentPage ? '#174384' : 'gainsboro',
                  cursor: "pointer"
                }}
                onClick={() => setCurrentPage(page + 1)}
              > {page + 1}
              </button>
                    );
                  }
                  return null;
                })}
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >Next
              </button>
              <span className={classes.pageText}>Displaying {startIndexx} - {endIndexx} of {totalEntries}</span>
            </div>
          </div>


        </div>
      </div>
      <Modal show={show1} onHide={handleClose1} animation={false} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>New Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form style={{ paddingLeft: "25px", paddingRight: "25px" }}>
              <Row style={{ marginBottom: "10px"}}>
                <Col md={6}>
                  <Form.Check
                    label="Supplier/Contractor"
                    name="group1"
                    type="radio"
                    id="supplier"
                    value="supplier"
                    checked={selectedRadio === "supplier"}
                    onChange={handleRadioChange}
                    className={classes.radioGreen}
                  />
                </Col>
                <Col md={6}>
                  <Form.Check
                    label="General Payment"
                    name="group1"
                    type="radio"
                    id="general"
                    value="general"
                    checked={selectedRadio === "general"}
                    onChange={handleRadioChange}
                    className={classes.radioGreen}
                  />
                </Col>
              </Row>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Row style={{ marginBottom: "15px" }}>
                 {selectedRadio === "supplier" && (
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Payment to:</label>
                      </Col>
                      <Col md={9}>
                          <Select
                            options={customerOptions}
                            value={selectedCustomer}
                            onChange={setSelectedCustomer}
                            placeholder="Select Supplier"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                      </Col>
                    </Row>
                  </Col>
                 )}
                 {selectedRadio === "general" && (
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Payment to:</label>
                      </Col>
                      <Col md={9}>
                          <Form.Control
                            type="text"
                            value={customerName}
                            onChange={(e) => {
                              const value = e.target.value;
                              const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                              setCustomerName(filteredValue);
                            }}
                            required
                            style={{ width: "100%" }}
                          />
                      </Col>
                    </Row>
                  </Col>
                 )}
                  <Col md={12} style={{ marginBottom: 10 }}>
                        <Row>
                          <Col md={3} style={{ textAlign: "right" }}>
                              <label style={{ width: "100%" }}>Date:</label>
                          </Col>
                          <Col md={9}>
                            <Form.Control
                              type="date"
                              value={paymentDate}
                              onChange={e => setPaymentDate(e.target.value)}
                              required
                              style={{ width: "100%" }}
                            />
                          </Col>
                        </Row>
                  </Col>
                  <Col md={12} style={{ marginBottom: 10 }}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label style={{ width: "100%" }}>Description:</label>
                    </Col>
                      <Col md={9}>
                        <Form.Control
                          as="textarea"
                          value={description}
                          rows={1}
                          onChange={(e) => {
                            const value = e.target.value;
                            const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                            setDescription(filteredValue);
                          }}
                          required
                          style={{ width: "100%" }}
                        />
                      </Col>
                  </Row>
                  </Col>
                  <Col md={12}>
                      <Row>
                        <Col md={3} style={{ textAlign: "right" }}>
                          <label>Mode:</label>
                        </Col>
                        <Col md={9}>
                          <Select
                            options={paymentMode}
                            value={selectedPaymentMode}
                            onChange={setSelectedPaymentMode}
                            placeholder="Select Payment Mode"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                        </Col>
                      </Row>
                  </Col>
              </Row>
              <Row>
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Currency:</label>
                      </Col>
                      <Col md={9}>
                        <Row>
                          <Col md={5}>
                            <Select
                              options={currencyOptions}
                              value={selectedCurrency}
                              onChange={setSelectedCurrency}
                              placeholder="Currency"
                              isClearable
                              classNamePrefix="react-select"
                              required
                            />
                          </Col>
                          <Col md={7}>
                            <Row>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <label style={{ width: "100%" }}>Amount:</label>
                              </Col>
                              <Col md={8}>
                              <CurrencyInput
                                id="total-amount"
                                name="totalAmount"
                                value={amount}
                                decimalsLimit={2}
                                onValueChange={(value) => setAmount(value)}
                                prefix="₦"
                                groupSeparator=","
                                placeholder="Amount"
                                className={`form-control ${classes.optioncss}`}
                              />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Credit:</label>
                      </Col>
                      <Col md={9}>
                        <Row>
                          <Col md={5}>
                            <Select
                              options={bankOptions}
                              value={selectedBank}
                              onChange={setSelectedBank}
                              placeholder="Account"
                              isClearable
                              classNamePrefix="react-select"
                              required
                            />
                          </Col>
                          <Col md={7}>
                            <Row>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <label style={{ width: "100%" }}>Debit:</label>
                              </Col>
                              <Col md={8}>
                                <Select
                                  options={bankOptions2}
                                  value={selectedBank2}
                                  onChange={setSelectedBank2}
                                  placeholder="Account"
                                  isClearable
                                  classNamePrefix="react-select"
                                  required
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
              </Row>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ paddingLeft: "25px", paddingRight: "25px" }}>
          <Button variant="light" onClick={handleClose1}>
            Go back
          </Button>
          <Button variant="success" onClick={addPayment} disabled={addpaymenntLoad} className={classes.btnss}>
              {addpaymenntLoad ? (
                <>
                  <Spinner size="sm" />
                  <span style={{ marginLeft: "5px" }}>
                    Processing, Please wait...
                  </span>
                </>
              ) : (
                "Save Payment"
              )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show2} onHide={handleClose2} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>New Supplier's Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Row style={{ marginBottom: "15px" }}>
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Payment to:</label>
                      </Col>
                      <Col md={9}>
                          <Select
                            options={invoiceOptions}
                            value={selectedInvoice}
                            onChange={(option) => {
                              setSelectedInvoice(option);
                              setAmount(option?.balance || "");
                            }}
                            // onChange={setSelectedInvoice}
                            placeholder="Select Supplier"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                          <label style={{ width: "100%" }}>Date:</label>
                      </Col>
                      <Col md={9}>
                        <Form.Control
                          type="date"
                          value={paymentDate}
                          onChange={e => setPaymentDate(e.target.value)}
                          required
                          style={{ width: "100%" }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12} style={{ marginBottom: 10 }}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label style={{ width: "100%" }}>Description:</label>
                    </Col>
                      <Col md={9}>
                        <Form.Control
                          as="textarea"
                          value={description}
                          rows={1}
                          onChange={(e) => {
                            const value = e.target.value;
                            const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                            setDescription(filteredValue);
                          }}
                          required
                          style={{ width: "100%" }}
                        />
                      </Col>
                  </Row>
                  </Col>
                  <Col md={12}>
                      <Row>
                        <Col md={3} style={{ textAlign: "right" }}>
                          <label>Mode:</label>
                        </Col>
                        <Col md={9}>
                          <Select
                            options={paymentMode}
                            value={selectedPaymentMode}
                            onChange={setSelectedPaymentMode}
                            placeholder="Select Payment Mode"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                        </Col>
                      </Row>
                  </Col>
              </Row>
              <Row>
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Currency:</label>
                      </Col>
                      <Col md={9}>
                        <Row>
                          <Col md={5}>
                            <Select
                              options={currencyOptions}
                              value={selectedCurrency}
                              onChange={setSelectedCurrency}
                              placeholder="Currency"
                              isClearable
                              classNamePrefix="react-select"
                              required
                            />
                          </Col>
                          <Col md={7}>
                            <Row>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <label style={{ width: "100%" }}>Amount:</label>
                              </Col>
                              <Col md={8}>
                              <CurrencyInput
                                id="total-amount"
                                name="totalAmount"
                                value={amount}
                                decimalsLimit={2}
                                onValueChange={(value) => setAmount(value)}
                                prefix="₦"
                                groupSeparator=","
                                placeholder="Amount"
                                className={`form-control ${classes.optioncss}`}
                                readOnly
                              />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Credit:</label>
                      </Col>
                      <Col md={9}>
                        <Row>
                          <Col md={5}>
                            <Select
                              options={bankOptions}
                              value={selectedBank}
                              onChange={setSelectedBank}
                              placeholder="Account"
                              isClearable
                              classNamePrefix="react-select"
                              required
                            />
                          </Col>
                          <Col md={7}>
                            <Row>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <label style={{ width: "100%" }}>Debit:</label>
                              </Col>
                              <Col md={8}>
                                <Select
                                  options={bankOptions2}
                                  value={selectedBank2}
                                  onChange={setSelectedBank2}
                                  placeholder="Account"
                                  isClearable
                                  classNamePrefix="react-select"
                                  required
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
              </Row>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={handleClose2}>
            Go back
          </Button>
          <Button variant="success" onClick={addPayment2} disabled={addpaymenntLoad2} className={classes.btnss}>
              {addpaymenntLoad2 ? (
                <>
                  <Spinner size="sm" />
                  <span style={{ marginLeft: "5px" }}>
                    Processing, Please wait...
                  </span>
                </>
              ) : (
                "Save Payment"
              )}
          </Button>
        </Modal.Footer>
      </Modal>
 <CashReciept
                isOpen={openCashReciept}
                onClose={() => setOpenCashReciept(false)}
            />

      {/* <Footer /> */}
    </div>
  );
};

export default CashReceiptss;
